var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.928 6.924c-.995 0-1.804.81-1.804 1.804v5.276c0 .995.84 1.836 1.836 1.836l6.079.037 1.276 2.38a.421.421 0 0 0 .419.22.421.421 0 0 0 .36-.306l.645-2.294h1.076c.995 0 1.804-.81 1.804-1.804v-5.31c0-.994-.81-1.803-1.804-1.803l-9.887-.036Z",
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.39 12.3a.656.656 0 0 0 .648-.66c0-.372-.3-.648-.648-.648a.635.635 0 0 0-.636.648c0 .372.288.66.636.66Zm2.604 0a.656.656 0 0 0 .648-.66c0-.372-.3-.648-.648-.648a.635.635 0 0 0-.636.648c0 .372.288.66.636.66Zm3.264-.66c0 .372-.3.66-.648.66a.646.646 0 0 1-.636-.66c0-.372.288-.648.636-.648.348 0 .648.276.648.648Z",
  fill: "#F4CC54"
})));
export default SvgLfChat;